export default "__VITE_ASSET__D5tXxH5w__"